import React, { useEffect, useState } from "react";

import { connect } from "react-redux";
import moment from "moment";

import { Link } from "react-router-dom";

import {
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Row,
  Button,
} from "reactstrap";
import { arrayValidation } from "helper/validation";
import { useHistory } from "react-router";
import { sortBy } from "helper/sortBy";
import { getGradeId } from "../utility.js";
import { Radio } from "antd";
import {
  setParams,
  setSortByState,
  fetchAllPlayers,
  publishStudent,
  publishColumnFilter,
  syncOfflineAudio,
} from "action/actions";

import { Tooltip, Switch } from "antd";

const OfflineSyncStudent = (props) => {
  const history = useHistory();
  const [checkID, setCheckID] = useState([]);
  const [isChecked, setIsChecked] = useState();
  const [filter, setFilter] = useState({
    name: "",
    date: "",
    level: "",
  });
  const [selectedStudent, setSelectedStudent] = useState({});

  useEffect(() => {
    props.fetchAllPlayers();
    // allTestListGet(props.globalState, dispatchAllTest);
  }, []);

  // console.log("sortByValue, orderBy", sortByValue, orderBy);
  // const tests = sortBy(sortType, allTestC.allTest, orderBy);
  // useEffect(() => {
  //   allTestC.allTest && setTests(sortBy("group", allTestC.allTest, orderBy));
  // }, [allTestC.allTest]);
  // if (!sortByValue) sortByValue = "group";
  // const tests =
  //   allTestC.allTest && sortBy(sortByValue, allTestC.allTest, orderBy);

  // console.log("test.js allTestC", allTestC);

  const TestColumnFilter = (e, state) => {
    console.log("column filter e.target.value", e.target.value);
    setFilter({
      ...filter,
      [state]: e.target.value,
    });
  };

  useEffect(() => {
    if (arrayValidation(props.students)) {
      props.publishColumnFilter(filter);
    }
  }, [filter]);

  let testStudents;
  if (arrayValidation(props.students)) {
    testStudents =
      props.students?.length !== 0 ? props.columnFilter : props.students;
    // testStudents = sortBy(sortType, studentList, orderBy);
  }

  // const handlePublish = (index) => {
  //
  //   setCheckID((prev) => [...prev, index]);
  //   props.publishStudent();
  // };

  const onTogglePublish = (e, i, myData) => {
    // let selectStudent = { ...selectedStudent };

    // if (e) {
    //   selectStudent[i] = myData;
    // } else {
    //   delete selectStudent[i];
    // }

    // setSelectedStudent(selectStudent);

    setIsChecked(e);
    // props.publishStudent(myData);
    props.syncOfflineAudio(myData);
  };

  // useEffect(() => {
  //   if (props.isPublished === "ERROR") {
  //     setCheckedState(!isChecked);
  //   } else {
  //     setCheckedState(isChecked);
  //   }
  // }, [props.isPublished]);

  return (
    <Container className="mb-4 mt-4 container-width-fix">
      <Card className="">
        <CardBody className="responsive-custom-card-body">
          <Row>
            <div
              className="responsive-test-card-header"
              // style={{
              //   display: "flex",
              //   justifyContent: "space-between",
              //   width: "95%",
              // }}
            >
              <div className="">
                <h3
                  style={{
                    color: "#444",
                  }}
                >
                  Offline Sync Score - Audio
                </h3>
              </div>
              <div
                className="d-flex"
                style={{
                  flexWrap: "wrap",
                }}
              >
                <Input
                  onChange={(e) => {
                    TestColumnFilter(e, "name");
                  }}
                  bsSize="sm"
                  id="exampleFormControlInput1"
                  placeholder="Name"
                  autoComplete="off"
                  type="text"
                  className="form-control mb-3 form-control-sm ml-2 mr-2 test-column-filter"
                />
                <Input
                  onChange={(e) => {
                    TestColumnFilter(e, "date");
                  }}
                  bsSize="sm"
                  id="exampleFormControlInputdate"
                  placeholder="Test Date"
                  type="text"
                  onFocus={(e) => (e.currentTarget.type = "date")}
                  className="form-control mb-3 form-control-sm ml-2 mr-2 test-column-filter"
                />

                <select
                  onChange={(e) => {
                    TestColumnFilter(e, "level");
                  }}
                  className="form-control mb-3 form-control-sm ml-2 mr-2 test-column-filter "
                >
                  <option value="">Select level</option>
                  <option value="2">L1</option>
                  <option value="5">L2</option>
                  <option value="8">L3</option>
                  <option value="12">L4</option>
                </select>

                {/* <select
                  // onChange={(e) => {
                  //   setSortType(e.target.value);
                  // }}
                  onChange={(e) =>
                    handleSortAndOrderChange({
                      pageName: "testList",
                      sortBy: e.target.value,
                      filterBy,
                      orderBy,
                    })
                  }
                  value={sortByValue || "group"}
                  className="form-control mb-3 form-control-sm ml-2 mr-2"
                  placeholder="Sort By"
                >
                  <option value="NA">--- Sort By ---</option>
                  <option value="testName">Name</option>
                  <option value="group">Group</option>
                  <option value="actionTag">Action Tag</option>
                </select>
                <Radio.Group
                  // onChange={(e) => {
                  //   setOrderBy(e.target.value);
                  // }}
                  onChange={(e) =>
                    handleSortAndOrderChange({
                      pageName: "testList",
                      sortBy: sortByValue,
                      filterBy,
                      orderBy: e.target.value,
                    })
                  }
                  value={orderBy}
                  optionType="button"
                  buttonStyle="solid"
                  className={"rad-btns"}
                >
                  <Radio.Button
                    className={`radio-btn-ctm `}
                    buttonStyle="solid"
                    value={"asc"}
                  >
                   
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      fill="currentColor"
                      className="bi bi-arrow-down"
                      viewBox="0 0 16 16"
                      style={{ coloe: "#fff" }}
                    >
                      <path
                        fillRule="evenodd"
                        d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z"
                      />
                    </svg>
                  </Radio.Button>
                  <Radio.Button
                    className={`radio-btn-ctm`}
                    buttonStyle="solid"
                    value={"dsc"}
                  >
                  
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="15"
                      fill="currentColor"
                      className="bi bi-arrow-up"
                      viewBox="0 0 16 16"
                      style={{ coloe: "#fff" }}
                    >
                      <path
                        fillRule="evenodd"
                        d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z"
                      />
                    </svg>
                  </Radio.Button>
                </Radio.Group> */}
              </div>
            </div>

            {/* {Object.keys(state.selectTest).length > 0 && (
              <div
                className="text-center border p-2 rounded d-flex align-items-center"
                style={{ height: "40px" }}
              >
                
                <div
                  className="h4 d-flex align-items-center"
                  style={{ fontSize: "17px" }}
                >
                  Total Test
                </div>
                {"  "}
                <div
                  className="h4 text-primary ml-1"
                  style={{ fontWeight: "bold", fontSize: "17px" }}
                >
                  {Object.keys(state.selectTest).length}
                </div>
              </div>
            )} */}

            <Col md="12">
              <div className="pr-2">
                <FormGroup>
                  {/* <Input
                    // onKeyUp={filterStudent}
                    bsSize="sm"
                    // id="exampleFormControlInput1"
                    placeholder="Search Test"
                    // type="email"
                  /> */}
                  {/* <select
                    // onChange={changeLevel}
                    className="form-control mt-2 mb-3 form-control-sm "
                  >
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                    <option>4</option>
                  </select> */}
                </FormGroup>
                <div style={{ height: "80vh", overflowY: "auto" }}>
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th className="small py-2 ">Name</th>
                        <th className="small py-2 ">Score</th>
                        <th className="small py-2">Sync Score</th>
                      </tr>
                    </thead>
                    <tbody>
                      {arrayValidation(testStudents) &&
                      testStudents.length &&
                      !props.notFound ? (
                        testStudents.map((student, index) => {
                          return (
                            <tr key={index}>
                              <td
                                className="py-2 d-flex "
                                style={{ cursor: "pointer" }}
                              >
                                {/* <div className="custom-control custom-checkbox pt-1 mr-1">
                                  <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    onChange={(e) =>
                                      handleCheckbox(e, index, {
                                        player_id: student.player_id,
                                      })
                                    }
                                    checked={
                                      state.selectStudent[index] ? true : false
                                    }
                                    id={student.player_id}
                                    value={student.player_id}
                                  />
                                  <label
                                    className="custom-control-label "
                                    htmlFor={student.player_id}
                                  />
                                </div> */}
                                <div
                                  className="text-dark d-flex  justify-content-between d-block"
                                  onClick={() => {
                                    history.push(
                                      // `/student/${student.player_id}/${student.grade_id}`
                                      `/student`
                                    );
                                    props.handleSetParams({
                                      id: student.player_id,
                                      gradeId: getGradeId(student.grade),
                                    });
                                  }}
                                >
                                  <div>
                                    <Tooltip
                                      title={`${student.firstname_dummy} ${student.lastname_dummy}`}
                                    >
                                      <div
                                        style={{
                                          textTransform: "capitalize",
                                          color: "#2B72FE",
                                          fontWeight: "500",
                                          lineHeight: "1.8",
                                        }}
                                      >
                                        {student.firstname} {student.lastname}
                                      </div>
                                    </Tooltip>
                                    <div
                                      className="small text-muted"
                                      style={{
                                        fontWeight: "500",
                                      }}
                                    >
                                      Age: {student.age}, Grade: {student.grade}
                                    </div>
                                    <div
                                      className="small text-muted"
                                      style={{
                                        fontWeight: "500",
                                      }}
                                    >
                                      {student.test_level},{" "}
                                      <Tooltip title="Test submit date">
                                        {moment(student.test_date).format(
                                          "DD-MM-YYYY"
                                        )}
                                      </Tooltip>
                                    </div>
                                  </div>
                                </div>
                              </td>

                              <td
                                className="py-2"
                                style={{ minWidth: "110px" }}
                              >
                                {student.total_score} / {student.max_score}
                              </td>
                              {/* <td className="py-2"></td> */}

                              <td style={{ minWidth: "85px" }}>
                                {/* <Link
                                  onClick={() => {
                                    handlePublish(index);
                                  }}
                                > */}
                                <select
                                  onChange={(e) => {
                                    const myData = {
                                      data: {
                                        assessor_id: props.accessor.id,
                                        player_id: student.id,
                                        grade_id: getGradeId(student.grade),
                                        is_published: e.target.value,
                                      },
                                    };
                                    onTogglePublish(e, index, myData);
                                  }}
                                  className="form-control mb-3 form-control-sm ml-2 mr-2 test-column-filter "
                                >
                                  <option
                                    selected={
                                      student.is_published === "Y"
                                        ? true
                                        : false
                                    }
                                    value="Y"
                                  >
                                    Y
                                  </option>
                                  <option
                                    selected={
                                      student.is_published === "N"
                                        ? true
                                        : false
                                    }
                                    value="N"
                                  >
                                    N
                                  </option>
                                </select>

                                {/* <div className="d-flex">
                                  <div className="">N</div>
                                  <Switch
                                    onClick={(e) => {
                                      const myData = {
                                        data: {
                                          player_id: student.id,
                                          grade_id: getGradeId(student.grade),
                                          // assessor_id: props.accessor.id,
                                          test_id: JSON.parse(
                                            localStorage.getItem("params")
                                          ).testId,
                                        },
                                      };
                                      onTogglePublish(e, index, myData);
                                    }}
                                    value={student.id}
                                    id={student.id}
                                    className="mx-1"
                                    checked={
                                      selectedStudent[index]
                                        ? props.isPublished === "ERROR"
                                          ? !isChecked
                                          : isChecked
                                        : false
                                    }
                                    // defaultChecked={student.grade === "3"}
                                    // checked={
                                    //   props.isPublished ? !isChecked : isChecked
                                    // }
                                  />
                                  <div className="d-flex ">Y</div>
                                </div> */}

                                {/* <div>
                                  {props.isUploaded ? (
                                    <i class="fas fa-check-circle"></i>
                                  ) : (
                                    <i class="fas fa-upload"></i>
                                  )}
                                </div> */}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <>
                          {props.notFound ? (
                            <tr>
                              {" "}
                              <td>Data Not Found</td>{" "}
                            </tr>
                          ) : (
                            <tr>
                              {" "}
                              <td>Loading...</td>{" "}
                            </tr>
                          )}
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Container>
  );
};

const mapToProp = (state) => {
  return {
    globalState: state.globaReducer,
    // filterProps: state.filterStateReducer,
    students: state.publishStudentReducer.all,
    isPublished: state.publishStudentReducer.isPublished,
    accessor: state.auth["master"][0],
    columnFilter: state.publishStudentReducer.columnfiltered,
    notFound: state.publishStudentReducer.notFound,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleSetParams: (params) => dispatch(setParams(params)),
    handleSortAndOrderChange: (data) => dispatch(setSortByState(data)),
    fetchAllPlayers: () => dispatch(fetchAllPlayers()),
    publishStudent: (data) => dispatch(publishStudent(data)),
    publishColumnFilter: (data) => dispatch(publishColumnFilter(data)),
    syncOfflineAudio: (data) => dispatch(syncOfflineAudio(data)),
  };
};

export default connect(mapToProp, mapDispatchToProps)(OfflineSyncStudent);
